module.exports = __webpack_public_path__ + "img/copy.85b58dde.svg";